import Vue from 'vue'
import Router from 'vue-router'
import { resolve } from 'url';

Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
            //pc端口开始
        {
            path: '/face',
            name: 'face',
            component:resolve => require(['@/components/mobile/FaceMobile'], resolve),
               
        },
        {
            path: '/PrintVip',
            name: 'PrintVip',
            component:resolve => require(['@/components/PrintVip'], resolve),
               
        },
        {
            path: '/consent',
            name: 'consent',
            component:resolve => require(['@/view/user/consent'], resolve),
               
        },
        {
        path: '/enroll',
        name: 'enroll',
        component:resolve => require(['@/view/enroll/Enroll'], resolve),
        redirect: {name:'payment'},
        children: [
            {
            path: 'selection',
            name: 'selection',
            component:resolve => require(['@/view/enroll/selection'], resolve),
           
            },
            {
            path: 'years',
            name: 'years',
            component:resolve => require(['@/view/enroll/years'], resolve),
            
            },
        
            {
            path: 'payment',
            name: 'payment',
            component:resolve => require(['@/view/enroll/payment'], resolve),
          
            },
            {
            path: 'finish',
            name: 'finish',
            component:resolve => require(['@/view/enroll/finish'], resolve),
           
            },
            {
                path: 'member',
                name: 'member',
                component:resolve => require(['@/view/enroll/member/member'], resolve),
               
            },
            {
                path: 'paymentmember',
                name: 'paymentmember',
                component:resolve => require(['@/view/enroll/member/payment'], resolve),
               
            },
        ]
        },
        {
            path: '/user',
            name: 'user',
            component:resolve => require(['@/view/user/UserView'], resolve),
            redirect: {name:'UserMessage'},
            children: [
            {
                path: 'courses',
                name: 'courses',
                component:resolve => require(['@/view/user/courses'], resolve),
               
            },
           
            {
                path: 'message',
                name: 'message',
                component:resolve => require(['@/view/user/message'], resolve),
              
            },
            {
                path: 'invoice',
                name: 'invoice',
                component:resolve => require(['@/view/user/invoice'], resolve),
              
            },
            {
                path: '/video/:id',
                name: 'video',
                component:resolve => require(['@/view/user/video'], resolve),
               
            },
            {
                path: '/examination/:id',
                name: 'examination',
                component:resolve => require(['@/view/user/examination'], resolve),
               
            },
            {
                path: 'results',
                name: 'results',
                component:resolve => require(['@/view/user/results'], resolve),
               
            },
            { 
                path: 'orders',
                name: 'orders',
                component:resolve => require(['@/view/user/orders'], resolve),
               
            },
            { 
                path: 'questions',
                name: 'questions',
                component:resolve => require(['@/view/user/questions'], resolve),
              
            },
            ]
        },
        {
            path:'/',
            redirect:{name:'judge'},
        },
        {
            path: '/judge',
            name: 'judge',
            component:resolve => require(['@/view/content/judge'], resolve),
           
        },
        {
            path: '/',
            name: 'Content',
            component:resolve => require(['@/view/content/Content'], resolve),
            redirect: {name:'index'},
            children: [
            {
                path: 'index',
                name: 'index',
                component:resolve => require(['@/view/content/index'], resolve),
               
            },
            {
                path: '/search/:id',
                name: 'search',
                component:resolve => require(['@/view/content/search'], resolve),
              
            },
            {
                path: 'list',
                name: 'list',
                component:resolve => require(['@/view/content/list'], resolve),
               
            },
            {
                path: 'article',
                name: 'article',
                component:resolve => require(['@/view/content/article'], resolve),
               
            }
            
            ]
        },
   //pc端口结束
   //手机端接口开始
    {
        path: '/',
        name: 'ContentMobile',
        component:resolve => require(['@/ContentMobile'], resolve),
        redirect: {name:'IndexM'},
        children: [
        {// 用户中心
            path: 'UserCenter',
            name: 'UserCenter',
            component:resolve => require(['@/view/admin/UserCenter'], resolve),
           
        },
        // { // admin 个人信息
        //     path: 'InformationView',
        //     name: 'InformationView',
        //     component:resolve => require(['@/view/admin/InformationView'], resolve),
        // },
        { // 入会
            path: 'EnrollMember',
            name: 'EnrollMember',
           
            component:resolve => require(['@/view/admin/member/EnrollMember'], resolve),
           
        },
        { // 入会
            path: 'EnrollInvoice',
            name: 'EnrollInvoice',
           
            component:resolve => require(['@/view/admin/member/EnrollInvoice'], resolve),
           
        },
        { // 入会
            path: 'EnrollPayment',
            name: 'EnrollPayment',
           
            component:resolve => require(['@/view/admin/member/EnrollPayment'], resolve),
           
        },
        { // 选课
            path: 'ChoiceCourse',
            name: 'ChoiceCourse',
           
            component:resolve => require(['@/view/admin/ChoiceCourse'], resolve),
           
        },
        { // 课程列表
            path: 'EnrollYears',
            name: 'EnrollYears',
            component:resolve => require(['@/view/admin/EnrollYears'], resolve),
           
        },
        { // 课程列表
            path: 'MobileFinish',
            name: 'MobileFinish',
           
            component:resolve => require(['@/view/admin/MobileFinish'], resolve),
           
        },
        { // 课程列表
            path: 'MobilePay',
            name: 'MobilePay',
            component:resolve => require(['@/view/admin/MobilePay'], resolve),
          
        },
        { // 课程列表
            path: 'CourseList',
            name: 'CourseList',
            component:resolve => require(['@/view/admin/CourseList'], resolve),
           
        },
        {
            path: 'ProblemView',
            name: 'ProblemView',
            component:resolve => require(['@/view/admin/ProblemView'], resolve),
          
        },
        { // 发票
            path: 'InvoiceView',
            name: 'InvoiceView',
            component:resolve => require(['@/view/admin/InvoiceView'], resolve),
           
        },
        { // 订单
            path: 'OrdersView',
            name: 'OrdersView',
            component:resolve => require(['@/view/admin/OrdersView'], resolve),
            
        },
        { //
            path: 'IndexM',
            name: 'IndexM',
            component:resolve => require(['@/view/admin/Index'], resolve),
           
        },
        // {
        //     path: 'CourseDetail',
        //     name: 'CourseDetail',
        //     component:resolve => require(['@/view/admin/CourseDetail'], resolve),
          
        // },
        {
            path: '/CourseDetail/:id',
            name: 'CourseDetail',
            component:resolve => require(['@/view/admin/CourseDetail'], resolve),
          
        },
        {
            path: 'TestResult',
            name: 'TestResult',
            component:resolve => require(['@/view/admin/TestResult'], resolve),
            
        },
        {
            path: '/OnlineTest/:id',
            name: 'OnlineTest',
            component:resolve => require(['@/view/admin/OnlineTest'], resolve),
           
        },
        ]
    }
  ]
})
// export 



// WEBPACK FOOTER //
// ./src/router/index.js